import api from '../../api/index';
import config from '@/assets/config.json';
const state = {}
const mutations = {

}
const getters = {
}
const actions = {
  //商家端-店铺申请-资质
  standardTalent({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/talent/list`,opt
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺申请-商品标准库
  standardList({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/goods/standard/list`,opt
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
/**
 * 
 * @param {以上是新修改的数据接口} param0 
 * @param {*以下是原来的} opt 
 * @returns 
 */
  //商家端-店铺装修-分类管理-替换
decorateSortChange({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/store/decorate/cate/sort/change`,{params:opt}
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-分类管理-排序
decorateSort({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/store/decorate/cate/sort`,{params:opt}
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-分类管理-删除
decorateSortDelete({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.delete(`${config.newHttps.api}/merchant/store/decorate/category/del`,{data:opt}
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-分类管理-编辑的保存
decorateSortEditSave({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/merchant/store/decorate/category/goods`,opt
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-分类管理-编辑的保存-删除
decorateSortEditDel({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.delete(`${config.newHttps.api}/merchant/store/decorate/cate/goods/del`,{data:opt}
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-分类管理-关联商品-编辑的保存
decorateSortCateSave({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/store/decorate/cate/goods/save`,opt
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-分类管理-关联商品-添加
decorateSortCateCreate({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/store/decorate/cate/goods/edit`,opt
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
//商家端-店铺装修-分类管理-关联商品列表（添加编辑）
decorateSortCate({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/store/decorate/cate/goods/add`,opt
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-分类列表
decorateSortList({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/store/decorate/cate/list`,{params:opt}
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-推荐商品-删除
decorateGoodsDel({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.delete(`${config.newHttps.api}/merchant/store/decorate/goods/del`,{data:opt}
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-推荐商品-排序
decorateGoodsSort({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/merchant/store/decorate/goods/sort`,opt
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-推荐商品-列表
decorateGoodsAdd({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/store/decorate/goods/add`,opt
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
  //商家端-店铺装修-推荐商品-列表
decorateGoodsList({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/store/decorate/goods/list`, {
          params: opt
      }).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
//商家端-店铺装修-品牌介绍-编辑
decorateShopEdit({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/store/decorate/edit`,opt
      ).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
//商家端-店铺装修-品牌介绍-列表
decorateShopList({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/store/decorate/shop/list`, {
          params: opt
      }).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
//商家端-店铺装修-品牌介绍-详情
decorateList({
  rootState,
  commit
}, opt) { 
  return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/store/decorate/list`, {
          params: opt
      }).then(data => {
          if (data) {
              resolve(data);
          }
      }).catch((err) => {
          console.log(err);
      });
  });
},
//卖家地理位置
    areaCount({
        rootState,
        commit
    }, opt) { //卖家地址位置
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/consolestatistic/areacount`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
//最近趋势-按授权
authorizeCount({
        rootState,
        commit
    }, opt) { //卖家地址位置
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/product/authorize/chart`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
//最近趋势-按授权
platCount({
        rootState,
        commit
    }, opt) { 
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/product/shop/platform`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    productShopChart({
        rootState,
        commit
    }, opt) { 
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/product/shop/chart`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    productShopDetailsChart({
        rootState,
        commit
    }, opt) { 
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/product/chart`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
//产品检测-详情-详情-表格
    productDetailList({
        rootState,
        commit
    }, opt) { //应用套餐
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/shop/product/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //产品检测-详情-详情-折线图
    productDetailchartd({
        rootState,
        commit
    }, opt) { //应用套餐
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/product/price/chart`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //sku检测-详情-详情-折线图
    chartPieAPI({
        rootState,
        commit
    }, opt) { //应用套餐
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/product/platform/chart`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },



    pricemonitorList({
        rootState,
        commit
    }, opt) { //价格预警列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/consolestatistic/pricemonitorlist`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    shopChart({
        rootState,
        commit
    }, opt) { //应用套餐
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/product/shop/chart`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    applicationCombo({
        rootState,
        commit
    }, opt) { //应用套餐
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/application/combo/${opt.id}`, {
                params: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    skuChart({
        rootState,
        commit
    }, opt) { //
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/product/sku/chart`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    shopDel({
        rootState,
        commit
    }, opt) { //同意协议
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/console/shop/del`, {
                data: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    updateAccept({
        rootState,
        commit
    }, opt) { //同意协议
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/users/update/accept`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    resultInfo({
        rootState,
        commit
    }, opt) { //发布商品分类
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/info`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    couponsRecorde({
        rootState,
        commit
    }, opt) { //发布商品分类
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/coupons/card/record`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    couponsCardBalance({
        rootState,
        commit
    }, opt) { //余额
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/coupons/cardbalance`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    activityName({
        rootState,
        commit
    }, opt) { //发布商品分类
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/activity/mains/name`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    couponsCreateOrder({
        rootState,
        commit
    }, opt) { //订单支付
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/coupons/create/order`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    yearGoodsActivity({
        rootState,
        commit
    }, opt) { //
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/activity/goods/create`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    shopCategory({
        rootState,
        commit
    }, opt) { //发布商品分类
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/shop/category/name`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    paymentList({
        rootState,
        commit
    }, opt) { //支付记录
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/coupons/paymentlist`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    importCard({
        rootState,
        commit
    }, opt) { //发卡导入
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/couponskind/issuecoupons`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    couponsCreate({
        rootState,
        commit
    }, opt) { //发卡
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/coupons/create`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    couponsList({
        rootState,
        commit
    }, opt) { //发卡列表
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/coupons/list`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    trademarkInfo({
        rootState,
        commit
    }, opt) { //获取商标
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/store/apply/trademark/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },



    agencyMessageUpadte({
        rootState,
        commit
    }, opt) { //通知已读
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/notice/agency/message/status`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },



    agencyMessage({
        rootState,
        commit
    }, opt) { //通知
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/notice/agency/message`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },



    getThisTokenShop({
        rootState,
        commit
    }, opt) { //类目申请记录
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/open/account/getThisTokenShop`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    argumentsName({
        rootState,
        commit
    }, opt) { //类目申请记录
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/goods/category/arguments/name`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    // 选择商家店铺
    selectMerchantShop ( { rootState, commit }, opt ) {
        return new Promise((resolve, reject) => {
            api.post(`http://116.90.87.11:39999/merchant/shop/list`, 
                opt ).then(data => {
                    if (data) {
                        resolve(data);
                    }
                }).catch((err) => {
                    console.log(err);
                });
        });
    },
    
    // 选择店铺下的标品


    shopName({
        rootState,
        commit
    }, opt) { //类目申请记录
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/brands/list`, {
            // api.get(`${config.brandHttps.api}/merchant/brands/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    platform({
        rootState,
        commit
    }, opt) { //检测平台
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/consoleplan/platform`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    checkPass({
        rootState,
        commit
    }, opt) { //注册登录
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/users/check/pass`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    categoryAdd({
        rootState,
        commit
    }, opt) { //类目申请记录
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/storeapply/category/add`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    categoryHistory({
        rootState,
        commit
    }, opt) { //类目申请记录
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/storeapply/category/history`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    categoryRecharge({
        rootState,
        commit
    }, opt) { //类目押金充值
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/store/apply/category/recharge`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    categoryMessage({
        rootState,
        commit
    }, opt) { //类目管理
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/storeapply/category/message`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    shopInfo({
        rootState,
        commit
    }, opt) { //店铺资料修改
        return new Promise((resolve, reject) => {
            api.get(`${config.newHttps.api}/merchant/store/base/show`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    shopInfoUpdate({
        rootState,
        commit
    }, opt) { //店铺资料修改
        return new Promise((resolve, reject) => {
            api.put(`${config.newHttps.api}/merchant/store/base/message`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    storeapplyGoods({
        rootState,
        commit
    }, opt) { //已申请铺列表
        return new Promise((resolve, reject) =>{
            api.get(`${config.newHttps.api}/merchant/store/apply/goods/number`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    storeapplyMoney({
        rootState,
        commit
    }, opt) { //获取类目和资质信息
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/storeapply/money`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    storeCageter({
        rootState,
        commit
    }, opt) { //获取店铺类目
        return new Promise((resolve, reject) => {
          let params={
            token:opt.token
          }
            api.get(`${config.brandHttps.api}/merchant/goods/classifys/shop/${opt.id}`,
             {params:params}
             
             ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
///merchant/storeapply/shop/pay
    storeapplyPay({
        rootState,
        commit
    }, opt) { //店铺支付
        return new Promise((resolve, reject) => {
            api.post(`${config.newHttps.api}/merchant/store/apply/shop/pay`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    applylist({
        rootState,
        commit
    }, opt) { //店铺详情
        return new Promise((resolve, reject) => {
            api.get(`${config.newHttps.api}/merchant/store/apply/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    storeApply({
        rootState,
        commit
    }, opt) { //店铺申请
        return new Promise((resolve, reject) => {
            api.post(`${config.newHttps.api}/merchant/store/apply/store/list`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    categoryManges({
        rootState,
        commit
    }, opt) { //查询分类信息
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/store/apply/category`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    shoptypelist({
        rootState,
        commit
    }, opt) { //店铺类型列表
        return new Promise((resolve, reject) => {
            api.get(`${config.newHttps.api}/merchant/store/apply/shop/type/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    serviceShow({
        rootState,
        commit
    }, opt) { //价格监测的显示
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/consoleplan/service`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    openAccountWx({
        rootState,
        commit
    }, opt) { //微信进件
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/open/account/openAccountWx`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    openAccountCheckWx({
        rootState,
        commit
    }, opt) { //微信进件查询
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/open/account/openAccountCheckWx`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    apliySubmitquery({
        rootState,
        commit
    }, opt) { //微信进件查询
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/alipay/submitquery`, {
              params: opt
          }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    wxUpload({
        rootState,
        commit
    }, opt) { //微信文件上传
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/open/account/wxUpload`, opt).then(data => {
            
                if (data) {                
                    resolve(data);
                }
            }).catch((err) => {
              reject(err)
                //console.log(err);
            });
        });
    },
    apliyUpload({
        rootState,
        commit
    }, opt) { //支付宝文件上传
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/pay/alipay/submituploadfile`, opt).then(data => {
            
                if (data) {                
                    resolve(data);
                }
            }).catch((err) => {
              reject(err)
                //console.log(err);
            });
        });
    },

    consoleplanDelete({
        rootState,
        commit
    }, opt) { //sku-产品检测删除
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/consoleplan/${opt.id}`, {
                params: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
              reject(err)
            });
        });
    },

    // 账单列表
    getPayment({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/payment`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    // 账单列表-详情
    getPaymentD({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/payment/${opt.id}`, {
                params: {
                  token: opt.token
              }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 平台下拉筛选
     */
    platformSelect({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/platform/select`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 店铺编辑
     */
    shopList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/shop/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    storeNameEdit({
      rootState,
      commit
  }, opt) {
      return new Promise((resolve, reject) => {
          api.put(`${config.newHttps.api}/merchant/store/apply/shop/edit`, opt).then(data => {
              if (data) {
                  resolve(data);
              }
          }).catch((err) => {
              console.log(err);
          });
      });
  },
    /**
     * 店铺编辑
     */
    shopEdit({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/console/shop/edit`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 店铺创建
     */
    shopAdd({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/console/shop/add`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 店铺列表
     */
    shopIndex({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/shop/index`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },






    /**
     * 价格检测编辑
     */
    consoleproductEdit({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/consoleplan/modify/${opt.id}`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 产品检测-检测方案-详情-折线图
     */
  /*   consoleplanChart({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/console/product/chart`, {
                params: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    }, */
    /**
     * 价格检测详情
     */
    consoleplanDetail({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/consoleplan/${opt.id}`, {
                params: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 价格检测详情列表
     */
    consoleplanDetailList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/consoleplan/detaillist`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 价格检测创建
     */
    consoleplanCreate({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/consoleplan/create`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 价格检测列表
     */
    consoleplanList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/consoleplan/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    // 推荐语

    getWords({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.shopHttps.api}/apimerchant/words/getwords`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    addWords({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.shopHttps.api}/apimerchant/words/addwords`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    editWords({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.shopHttps.api}/apimerchant/words/editwords`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    // 推荐语
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
